<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" @input="getLineListChange" />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="LineItems"
            type="search"
            itemText="lineCd"
            itemValue="lineId"
            name="lineId"
            label="라인"
            v-model="searchParam.lineId"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="processTable"
      title="공정 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :rowKey="rowKey"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="검색" icon="search" @btnClicked="getList" />
          <c-btn label="선택" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'process-pop',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: 'multiple',
        processLevelCd: '20',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      rowKey: 'processCd',
      listUrl: '',
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
          },
          {
            name: 'placeName',
            field: 'placeName',
            label: '장소(층)',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'lineCd',
            field: 'lineCd',
            label: '라인',
            align: 'center',
            sortable: true,
          },
          {
            name: 'upProcessName',
            field: 'upProcessName',
            label: '상위공정',
            align: 'center',
            sortable: true,
          },
          {
            name: 'processName',
            field: 'processName',
            label: '단위공정',
            align: 'center',
            sortable: true
          },
        ],
        data: [],
        height: '100%'
      },
      searchParam: {
        plantCd: null,
        lineId: null,
        processName: '',
        processLevelCd: '20',
      },
      LineItems: [],
      editable: true,
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    }
  },
  methods: {
    init() {
      if (this.popupParam.processLevelCd == '10') {
        this.rowKey = 'processCd';
        this.popupParam.type = 'single';
        this.grid.columns = [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
          },
          {
            name: 'processName',
            field: 'processName',
            label: '상위공정',
            align: 'center',
            sortable: true,
          },
        ];
      } else {
        this.rowKey = 'processCd';
        this.grid.columns = [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            sortable: true,
          },
          {
            name: 'upProcessName',
            field: 'upProcessName',
            label: '상위공정',
            align: 'center',
            sortable: true,
          },
          {
            name: 'processName',
            field: 'processName',
            label: '단위공정',
            align: 'center',
            sortable: true
          },
          {
            name: 'placeName',
            field: 'placeName',
            label: '장소(층)',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'lineCd',
            field: 'lineCd',
            label: '라인',
            align: 'center',
            sortable: true,
          },
        ];
      }
      this.listUrl = selectConfig.mdm.process.list.url;
      this.getList();
      this.getLineList();
    },
    getLineListChange() {
      this.getLineList();
      this.searchParam.lineId = null;
      this.grid.data = [];
    },
    getLineList() {
      this.$http.url = selectConfig.mdm.line.list.url;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.searchParam.plantCd,
        useFlag: 'Y',
      };
      this.$http.request((_result) => {
        this.LineItems = _result.data;
      },);
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.searchParam.processLevelCd = (this.popupParam.processLevelCd) ? this.popupParam.processLevelCd: '20';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['processTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '공정을 선택하세요.', // 공정을 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  }
};
</script>
